import UpdateUserGroupHtml from './templates/update_user_group.html';

export function UserManagementCtrl ($scope, $window, $uibModal, $state, $translate, confirm, messages, workshopAPI, sessionObjAPI) {
  $scope.editGroup = function (user, idx) {
    var modalInstance;

    modalInstance = $uibModal.open({
      templateUrl: UpdateUserGroupHtml,
      windowClass: 'sm-modal',
      controller: 'userGroupForUserCtrl',
      resolve: {
        user: ['workshopAPI', function (workshopAPI) {
          return user;
        }],
        userGroups: ['workshopAPI', function (workshopAPI) {
          return workshopAPI.get('/groups', ['*', '*']);
        }],
        idx: ['workshopAPI', function (workshopAPI) {
          return idx;
        }]
      }
    });

    modalInstance.result.then(function (accountType) {
      $state.reload();
    });


  };

  $scope.clearEmail = function (user) {
    confirm.generic($translate.instant('JS_SPACE.CONFIRM.CLEAR_EMAIL'))
      .then(() => {
        return workshopAPI.post('/workshop_admin/rename_username_and_log', { username: user.username });
      })
      .then((data) => {
        messages.show($translate.instant('JS_SPACE.MESSAGES.USERNAME_FREED_UP', { username: user.username }), 'success');
        $state.reload();
      })
      .catch((err) => {
        messages.error(err);
      });
  };

  $scope.saveEmail = function (user, idx) {
    workshopAPI.patch('/workshop_admin/update_user_email', user, 'user')
      .then(function (data) {
        $scope.users[idx] = data;

        messages.show($translate.instant('JS_SPACE.MESSAGES.EMAIL_UPDATED'), 'success');
      }, function (err) {
        messages.error(err);
      });
  };

  $scope.loginAs = function (user, dealer_superuser) {
    workshopAPI.get('workshop_admin/login_as', user.id)
      .then(function (session) {
        sessionObjAPI.setCookie(session.session_id);
        sessionObjAPI.setDealerCookie(dealer_superuser);
        $window.location = '/login.html?puppet=true';
      }, function (err) {
        messages.error(err);
      })
  };

  $scope.resetPassword = function (user, idx) {
    workshopAPI.patch('/workshop_admin/update_user_email', user, 'user')
      .then(function (data) {
        $scope.users[idx] = data;

        workshopAPI.post('/users/request_reset_email', user.email, 'email').
        then(function (data) {
          messages.show($translate.instant('JS_SPACE.MESSAGES.EMAIL_RESET_REQUEST'), 'success');
        }, function (err) {
          messages.error(err);
        });

      }, function (err) {
        messages.error(err);
      });
  };
}